import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M17.506 8.4093V5.9739c0-.3624-.1507-.71-.4191-.9663s-.6323-.4003-1.0119-.4003H8.0615c-.3795 0-.7435.144-1.0119.4003s-.419.6039-.419.9663v2.46c.0005.212.0524.4211.1517.6108s.2433.3548.4206.4825l3.4344 2.4599-3.4344 2.4599a1.39 1.39 0 0 0-.4206.4825 1.32 1.32 0 0 0-.1518.6108v2.46c0 .3624.1508.71.4191.9663.2684.2563.6324.4003 1.012.4003h8.0134c.3796 0 .7435-.144 1.0119-.4003s.4191-.6039.4191-.9663v-2.4354a1.325 1.325 0 0 0-.1501-.6101 1.39 1.39 0 0 0-.418-.4832l-3.4458-2.4845 3.4458-2.4873a1.39 1.39 0 0 0 .4174-.482 1.325 1.325 0 0 0 .1507-.6085m-1.7172 9.3177H8.3477v-2.05l3.7206-2.6649 3.7205 2.6875zm0-9.4537-3.7205 2.6888-3.7206-2.6649v-2.05h7.4411z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.3 2.2768c0-.429.3478-.7768.7769-.7768h13.7967a.7768.7768 0 0 1 0 1.5537H5.0769A.777.777 0 0 1 4.3 2.2768m0 19.4464c0-.429.3478-.7768.7769-.7768h13.7967a.7768.7768 0 0 1 0 1.5536H5.0769a.777.777 0 0 1-.7769-.7768",
        clipRule: "evenodd"
    }, "1")
], "Hourglass", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
